export default __webpack_public_path__ + "static/media/hair1.7f0750b2.png";